import { asLazy } from 'shared/utils/lazy.utils.js';

export const AccountPage = asLazy(
  import('./pages/AccountPage/index.js'),
  'AccountPage',
);
export const AccountsPage = asLazy(
  import('./pages/AccountsPage/index.js'),
  'AccountsPage',
);
export const ColleaguesPage = asLazy(
  import('./pages/ColleaguesPage/index.js'),
  'ColleaguesPage',
);
export const ColleagueViewPage = asLazy(
  import('./pages/ColleagueViewPage/index.js'),
  'ColleagueViewPage',
);
export const CompanyPage = asLazy(
  import('./pages/CompanyPage/CompanyPage.js'),
  'CompanyPage',
);
